module.exports = __webpack_public_path__ + "img/home-icon.01bbd61c.svg";